module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Patch-8a071236af21d8e7c16a5049fa173751.svg";